import { useState, useEffect } from 'react';

function SettingsFieldDisplay({ fieldName, defaultValue = '...' }) {
  const [fieldValue, setFieldValue] = useState('');

  useEffect(() => {
    fetch('/api/settings')
      .then((response) => response.json())
      .then((data) => {
        if (data[fieldName] !== undefined) {
          setFieldValue(data[fieldName]);
        } else {
          console.error(`Le champ ${fieldName} est manquant dans les données récupérées.`);
        }
      })
      .catch((error) => console.error(`Erreur lors de la récupération de ${fieldName} :`, error));
  }, [fieldName]); // fieldName dans les dépendances pour re-fetch si le prop change

  return (
    fieldValue || defaultValue
  );
}

export default SettingsFieldDisplay;